import React from "react";
import { Container } from "react-bootstrap";
import Link from "next/link";
import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";

import styles from "./styles/styles.module.scss";
import defaultBreadcrumb from "./assets/breadCrumb.avif";
import worksBreadcrumb from "./assets/works_breadcrumb.jpg";
import servicesBreadcrumb from "./assets/servics_breadcrumb.jpg";

const BreadCrumb = ({ title }) => {
  const router = useRouter();
  const { locale } = router;
  const isRtl = locale === "ar";
  const isServicesPage = router.pathname === "/services";
  const isWorksPage =
    router.pathname === "/ourworks" ||
    router.pathname === "/blogs" ||
    router.pathname === "/blogs/[slug]";
  const backgroundImage = isServicesPage
    ? servicesBreadcrumb
    : isWorksPage
      ? worksBreadcrumb
      : defaultBreadcrumb;

  return (
    <div
      className={styles["breads"]}
      dir={locale === "ar" ? "rtl" : "ltr"}
      style={{
        backgroundImage: `url(${backgroundImage.src || backgroundImage})`,
      }}
    >
      <Container>
        <div className={styles["breads__inner"]}>
          <div className={styles["breads__content"]}>
            <h1>{title}</h1>
            <Link href="/contactus" passHref>
              <a className={styles["cta-button-red"]}>
                <FormattedMessage id="contact-us" />

                <div className={styles["icon-circle"]}>
                  <svg
                    style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.53577 3.53556L14.1424 14.1422"
                      stroke="black"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                      stroke="black"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </a>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BreadCrumb;
